import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Supprimer ce commentaire si vous voulez faire un commit pour rien

// Sur un site hôte, seuls les web components d'App.js sont utilisés : il n'y a pas
// de #root. Sans ce garde, createRoot lève une erreur React #299 dans la console du
// site et interrompt la fin du bundle.
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
